import {
  FEEDBACK_ITEM_TYPES,
  FEEDBACK_ITEM_STATUSES,
  RENDER_FEEDBACK_CATEGORIES,
  PRODUCT_FEEDBACK_CATEGORIES
} from '../constants';

export default class FeedbackItem {
  static defaultProps = {
    type: FEEDBACK_ITEM_TYPES.PRODUCT,
    context: {},
    comment: '',
    categories: [],
    imageUrl: '',
    status: FEEDBACK_ITEM_STATUSES.STARTED,
    whRedesignRequestId: null,
    whFeedbackItemId: null
  };

  static buildFeedbackItemKey = ({ productId, renderId, designId, hotspotUuid, whRedesignRequestId }) => {
    let contextKey;

    const hasHotspotContext = !!(productId && designId && hotspotUuid);
    const hasRenderContext = !!(renderId && designId);
    const hasDesignContext = !!designId;

    switch (true) {
      case hasHotspotContext:
        contextKey = `hotspot-${hotspotUuid}-product-${productId}-design-${designId}`;
        break;
      case hasRenderContext:
        contextKey = `render-${renderId}-design-${designId}`;
        break;
      case hasDesignContext:
        contextKey = `design-${designId}`;
        break;
      default:
        contextKey = '';
        break;
    }
    console.log(contextKey);
    if (whRedesignRequestId) {
      return `${whRedesignRequestId}-${contextKey}`;
    }
    return contextKey;
  }

  constructor (overrides) {
    this.fields = { ...FeedbackItem.defaultProps, ...overrides };
  }

  id () {
    const { product, render, design, hotspot } = this.context();
    return FeedbackItem.buildFeedbackItemKey({
      productId: product && product.id(),
      renderId: render && render.id,
      designId: design && design.id(),
      hotspotUuid: hotspot && hotspot.instance_id,
      whRedesignRequestId: this.whRedesignRequestId()
    });
  }

  whRedesignRequestId () { return this.fields.whRedesignRequestId; }

  whFeedbackItemId () { return this.fields.whFeedbackItemId; }

  status () { return this.fields.status; }

  isStatusConfirmed () {
    return this.status() === FEEDBACK_ITEM_STATUSES.CONFIRMED;
  }

  type () { return this.fields.type; }

  isProductFeedback () {
    return this.type() === FEEDBACK_ITEM_TYPES.PRODUCT;
  }

  context () { return this.fields.context; }

  comment () { return this.fields.comment; }

  categories () { return this.fields.categories; }

  imageUrl () { return this.fields.imageUrl; }

  validate () {
    return this.comment() && this.categories().length > 0;
  }

  convertToWarehouseFeedbackItem () {
    const { product, design, render, hotspot } = this.context();
    const feedbackCategoryDict = this.type() === FEEDBACK_ITEM_TYPES.PRODUCT
      ? PRODUCT_FEEDBACK_CATEGORIES
      : RENDER_FEEDBACK_CATEGORIES;
    return {
      image_url: this.imageUrl(),
      comment: this.comment(),
      categories: this.categories().map((cat) => (
        feedbackCategoryDict[cat].value
      )),
      type: this.type(),
      status: this.status(),
      design_id: design && design.id(),
      render_id: render && render.id,
      product_id: product && product.id(),
      hotspot_uuid: hotspot && hotspot.instance_id
    };
  }

  makeCopy (overrides) {
    return new FeedbackItem({ ...this.fields, ...overrides });
  }
}
